/* src/views/CustomersView.js */
import { ref, onMounted, computed} from 'vue' // <-- Importa onMounted
import { Plus, Edit, Trash2, X, Check, Minus, Search } from 'lucide-vue-next'
import { CustomerService } from '@/services/CustomerService' // <-- Assicurati che l'import sia corretto
import Swal from 'sweetalert2'

export default {
  name: 'CustomersView',

  components: {
    Plus, Edit, Trash2, X, Check, Minus, Search,
  },
  
  setup() {
    const customers = ref([])
    const searchQuery = ref('')
    const isDrawerOpen = ref(false)
    const editingCustomer = ref(null)
    const formFirstName = ref('')
    const formLastName = ref('')
    const formPhone = ref('')
    const formEmail = ref('')
    const formWhatsapp = ref('')
    const formTelegram = ref('')
    const formIsActive = ref(true)

    const fetchCustomers = async () => {

      try {
      
        customers.value = await CustomerService.getAll()
      } 
      catch (error) {
      
        console.error("Errore nel caricamento:", error)
      }
    }

    onMounted(() => {
    
      fetchCustomers()
    })

    const openDrawer = (customer = null) => {
      
      if (customer) {
      
        editingCustomer.value = customer
        formFirstName.value = customer.firstName
        formLastName.value = customer.lastName
        formPhone.value = customer.phone
        formEmail.value = customer.email
        formWhatsapp.value = customer.whatsapp
        formTelegram.value = customer.telegram
        formIsActive.value = customer.isActive
      } 
      else {
      
        editingCustomer.value = null
        formFirstName.value = ''
        formLastName.value = ''
        formPhone.value = ''
        formEmail.value = ''
        formWhatsapp.value = ''
        formTelegram.value = ''
        formIsActive.value = true
      }
      
      isDrawerOpen.value = true
    }

    const filteredCustomers = computed(() => {
    
      if (!searchQuery.value.trim()) {
    
        return customers.value
      }

      const query = searchQuery.value.toLowerCase()
      
      return customers.value.filter(c => {
    
        const firstName = (c.firstName || '').toLowerCase()
        const lastName = (c.lastName || '').toLowerCase()
        const phone = (c.phone || '')
        const email = (c.email || '').toLowerCase()

        return firstName.includes(query) || 
               lastName.includes(query) || 
               phone.includes(query) || 
               email.includes(query)
      })
    })

    const closeDrawer = () => {

      isDrawerOpen.value = false
      
      setTimeout(() => {
        editingCustomer.value = null
        formFirstName.value = ''
        formLastName.value = ''
        formPhone.value = ''
        formEmail.value = ''
        formWhatsapp.value = ''
        formTelegram.value = ''
        formIsActive.value = true
      }, 300)
    }

    const saveCustomer = async () => {

      if (!formFirstName.value.trim() || !formLastName.value.trim() || !formPhone.value.trim()) {

        return
      }

      const customerData = {
        firstName: formFirstName.value.trim(),
        lastName: formLastName.value.trim(),
        phone: formPhone.value.trim(),
        email: formEmail.value.trim(),
        whatsapp: formWhatsapp.value.trim(),
        telegram: formTelegram.value.trim(),
        isActive: formIsActive.value
      }

      try {

        if (editingCustomer.value) {

          await CustomerService.update(editingCustomer.value.id, customerData)
        } 
        else {
        
          await CustomerService.create(customerData)
        }
        
        await fetchCustomers() // Ricarica la lista aggiornata dal server
        closeDrawer()
      } 
      catch (error) {

        Swal.fire({
            title: 'Errore',
            text: "Errore durante il salvataggio",
            icon: 'error',
            confirmButtonText: 'Chiudi'
        })
      }
    }

    const deleteCustomer = async (id) => {
      
      if (confirm('Sei sicuro di voler eliminare questo cliente?')) {
      
        try {
      
          await CustomerService.delete(id)
          await fetchCustomers()
        } 
        catch (error) {

          Swal.fire({
            title: 'Errore',
            text: "Errore durante eliminazione",
            icon: 'error',
            confirmButtonText: 'Chiudi'
          })
        }
      }
    }

    // Tutto ciò che serve al template va qui
    return {
      Check,
      closeDrawer,
      customers,
      deleteCustomer,
      editingCustomer,
      filteredCustomers, // Assicurati che sia qui
      formEmail,
      formFirstName,
      formIsActive,
      formLastName,
      formPhone,
      formTelegram,
      formWhatsapp,
      isDrawerOpen,
      Minus,
      openDrawer,
      saveCustomer,
      searchQuery,
    }
  }
}